export const LOAD_CATEGORIAS = "LOAD_CATEGORIAS";
export const SET_PAGE_CATEGORIA = "SET_PAGE_CATEGORIA";
export const SET_PERPAGE_CATEGORIA = "SET_PERPAGE_CATEGORIA";
export const SET_TOTAL_CATEGORIA = "SET_TOTAL_CATEGORIA";
export const SET_CATEGORIA = "SET_CATEGORIA";
export const LOADING_CATEGORIA = "LOADING_CATEGORIA";
export const SET_FILTRO_CATEGORIA = "SET_FILTRO_CATEGORIA";

export const LOAD_SUBCATEGORIAS = "LOAD_SUBCATEGORIAS";
export const SET_PAGE_SUBCATEGORIA = "SET_PAGE_SUBCATEGORIA";
export const SET_PERPAGE_SUBCATEGORIA = "SET_PERPAGE_SUBCATEGORIA";
export const SET_TOTAL_SUBCATEGORIA = "SET_TOTAL_SUBCATEGORIA";
export const SET_SUBCATEGORIA = "SET_SUBCATEGORIA";
export const LOADING_SUBCATEGORIA = "LOADING_SUBCATEGORIA";
export const SET_FILTRO_SUBCATEGORIA = "SET_FILTRO_SUBCATEGORIA";
